import React from 'react';
import {Grid, Typography, styled } from '@mui/material';
import { GatsbyImage } from 'gatsby-plugin-image';
import Rand from 'rand-seed';
import { ImageSet, CustomFields } from '../../types/app';

interface RandomImagesProps {
  seed : string;
  count ?: number;
  imageContainerProps ?: object;
  interval ?: number;
  imageSet : ImageSet;
  [key: string] : any; // For any additional props
}

/*
const getRandomImages = (images: any[], n: number) => {
  const shuffled = images.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
};
*/

const getRandomImages = (images : any[], n : number, seed : string = "") : any[] => {
  const rng = new Rand(seed);
  const shuffled = images
    .map(value => ({ value, sort: rng.next() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
  return shuffled.slice(0, n);
};

const StyledImageContainer = styled('div')`
  aspect-ratio: 1.41
`;

const StyledImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const obj = {};

const RandomImages: React.FC<RandomImagesProps> = ({ seed : seedIn = "", imageSet = null, count = 9, xs = 2, interval = 0, imageContainerProps = obj }) => {

  const [increment, setIncrement] = React.useState(0);

  const seed = React.useMemo(() => `${seedIn}_${increment}`, [seedIn, increment])
  
  // Refresh when location changes
  const randomImages = React.useMemo(() => (
    getRandomImages((imageSet?.images as CustomFields.Image[]), count, seed)
  ), [seed, increment, count, JSON.stringify(imageSet?.images) ])

  // Auto Increment
  React.useEffect(() => {
    
    if(interval <= 0) 
      return;

    const rotateInterval = setInterval(() => (
      setIncrement(prev => prev + 1)
    ), interval);

    return () => clearInterval(rotateInterval);

  },[interval])

  // None
  if(!randomImages || !randomImages.length)
    return null;

  // Process
  return (
    <Grid container spacing={0}>
      {
        false && 
        <Grid xs={12} item>
          <Typography>
            {seed}
          </Typography>
        </Grid>
      }
      {
        randomImages.map((image,ix) => (
          <Grid xs={xs} item key={image?.contentful_id || ix}>
            <StyledImageContainer {...imageContainerProps}>
              <StyledImage image={image.gatsbyImageData} alt={image?.title || ""} />
            </StyledImageContainer>
          </Grid>
        ))
      }
    </Grid>
  );
};

export default RandomImages;
